var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOffice = function SvgOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19.545 19.504"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Group 2609"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.782 14.497v-2.5",
    "data-name": "Path 18597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.804 3.297a2.991 2.991 0 0 1 2.967 3.02v3.4a17.817 17.817 0 0 1-9 2.28 17.78 17.78 0 0 1-8.989-2.28V6.308a2.99 2.99 0 0 1 2.977-3.011Z",
    "data-name": "Path 18598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.236 3.292v-.361A2.182 2.182 0 0 0 11.055.75H8.508a2.182 2.182 0 0 0-2.181 2.181v.361",
    "data-name": "Path 18599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.771 8.383.216 7.412a3.178 3.178 0 0 0 3.152 2.959h11.276a3.178 3.178 0 0 0 3.152-2.959l.2-6.479",
    "data-name": "Path 18600"
  }))));
};
export default SvgOffice;